import { cloneDeep } from 'lodash-es';

export const getDefaultActions = () => {
    let actions = [];
    let files = require.context('./', true, /\.js$/i);

    files.keys().map(key => {
        let filename = key.split('/').pop().split('.')[0];
        if (filename !== 'index') {
            let fileActions = require(`${key}`);
            actions = actions.concat(cloneDeep(fileActions.default));
        }
    });

    return actions;
};
